import { classNames } from '@library/utils';

interface SpinnerProps {
  className?: string;
}

export const Spinner = ({ className = '' }: SpinnerProps) => {
  return (
    <div
      className={classNames(
        'border-soClean-100 inline-block size-4 animate-spin rounded-full border-2 border-solid border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
        className
      )}
    />
  );
};
